export default () => 'ontouchstart' in global;
